// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-container {
    font-family: 'Segoe UI', sans-serif;
    background: #f9f9f9;
    padding: 2rem;
    min-height: 100vh;
}

.privacy-wrapper {
    max-width: 800px;
    margin: 0 auto;
    background: white;
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 8px 16px rgba(0,0,0,0.08);
    position: relative;
}

.privacy-header h1 {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    color: #111827;
}

.privacy-section {
    margin-bottom: 1.5rem;
}

.privacy-toggle {
    width: 100%;
    background: #f3f4f6;
    padding: 1rem;
    border: none;
    font-weight: 600;
    text-align: left;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-size: 1rem;
    border-radius: 0.5rem;
}

.privacy-content {
    padding: 1rem;
    background: #fdfdfd;
    border-left: 3px solid #3b82f6;
    border-radius: 0 0 0.5rem 0.5rem;
    margin-top: 0.5rem;
    line-height: 1.6;
}

.privacy-note {
    margin-top: 1rem;
    padding: 1rem;
    background: #e0f2fe;
    border-radius: 0.5rem;
    font-size: 0.95rem;
}

.privacy-note a {
    color: #2563eb;
    text-decoration: underline;
}

.privacy-footer {
    margin-top: 2rem;
    font-size: 0.9rem;
    color: #6b7280;
    text-align: center;
}

.scroll-top-button {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    background-color: #3b82f6;
    color: white;
    font-size: 1.5rem;
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 50;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Confidentiality/privacy.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,WAAW;AACf","sourcesContent":[".privacy-container {\n    font-family: 'Segoe UI', sans-serif;\n    background: #f9f9f9;\n    padding: 2rem;\n    min-height: 100vh;\n}\n\n.privacy-wrapper {\n    max-width: 800px;\n    margin: 0 auto;\n    background: white;\n    padding: 2rem;\n    border-radius: 16px;\n    box-shadow: 0 8px 16px rgba(0,0,0,0.08);\n    position: relative;\n}\n\n.privacy-header h1 {\n    font-size: 1.8rem;\n    margin-bottom: 1.5rem;\n    color: #111827;\n}\n\n.privacy-section {\n    margin-bottom: 1.5rem;\n}\n\n.privacy-toggle {\n    width: 100%;\n    background: #f3f4f6;\n    padding: 1rem;\n    border: none;\n    font-weight: 600;\n    text-align: left;\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n    font-size: 1rem;\n    border-radius: 0.5rem;\n}\n\n.privacy-content {\n    padding: 1rem;\n    background: #fdfdfd;\n    border-left: 3px solid #3b82f6;\n    border-radius: 0 0 0.5rem 0.5rem;\n    margin-top: 0.5rem;\n    line-height: 1.6;\n}\n\n.privacy-note {\n    margin-top: 1rem;\n    padding: 1rem;\n    background: #e0f2fe;\n    border-radius: 0.5rem;\n    font-size: 0.95rem;\n}\n\n.privacy-note a {\n    color: #2563eb;\n    text-decoration: underline;\n}\n\n.privacy-footer {\n    margin-top: 2rem;\n    font-size: 0.9rem;\n    color: #6b7280;\n    text-align: center;\n}\n\n.scroll-top-button {\n    position: fixed;\n    bottom: 2rem;\n    right: 2rem;\n    background-color: #3b82f6;\n    color: white;\n    font-size: 1.5rem;\n    border: none;\n    border-radius: 50%;\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    z-index: 50;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
